import React from 'react';
import classNames from 'classnames';

import Button from '../Button';
import Image from '../Image';

const ns = `full-width-banner`;

const FullWidthBanner = ({
	title,
	description,
	link,
	image,
	fullWidthBannerFontIsDark
}) => {
	const rootClassnames = classNames({
		[`${ ns }`]: true,
		[`${ ns }--color-white`]: fullWidthBannerFontIsDark === "false",
	});

	return (
		<div className={rootClassnames}>
			<div className={`${ ns }__media`}>
				<Image dataMedia {...image} />
			</div>
			<div className={`${ ns }__wrapper`}>
				<div className={`${ ns }__container`}>
					<div className={`${ ns }__content`}>
						<div className={`${ ns }__title h2`}>
							{title}
						</div>
						<div className={`${ ns }__description`}>
							{description}
						</div>
						{link?.url && link?.label && (
							<div className={`${ ns }__cta`}>
								<Button to={link.url}>
									{link.label}
								</Button>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default FullWidthBanner;
